import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
COMPLEX THINKING MODEL
</span></div>
                                            <p>Making complex ideas simple can be seen as a logical process.
                                                You start off with an idea (complex
                                                idea/concept), you then have to understand it yourself
                                                (defining the elements) and put it into a
                                                simple order, to convey it (logical hierarchy established).
                                                You then need to consider who you are
                                                putting the idea across to (define audience) and your
                                                approach (select and implement
                                                communications channel).</p>
                                            <p>Of course, this does not always work – there often comes a
                                                time in the process where information
                                                needs to be reviewed and put forward in a different way, to
                                                make it appear simpler for the
                                                audience (the feedback loop). As shown in the model, this
                                                tends to happen when you convey your
                                                idea. You may have to go through this stage a number of
                                                times in order to reach the final point
                                                where you get the idea across (audience understands).</p>

                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/flow_chart.png')}/>
                                            </div>


                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
ANYONE FOR CHARADES?
</span></div>
                                            <p>Have you ever played Charades, Pictionary or a similar game?
                                                How frustrating is it when your
                                                audience are just not getting your very obvious actions or
                                                the things you‘re drawing? They can‘t
                                                follow the logic in your head. These games work on the basis
                                                of making simple things complex
                                                by imposing restrictions. By understanding this process you
                                                can reverse it to make complex
                                                things simple.</p>

                                            <div
                                                className="lightgreencontentbg keyquestionpadnew uiheading lightbgcenter">
                                                <div className="paraspace"><p><span
                                                    className="green brownbold">To make simple things complex we often do the following:</span>
                                                </p></div>
                                                <ul className="greenbullet-list">
                                                    <li><p>Remove the ability to name/label things</p></li>
                                                    <li><p>Impose time constraints</p></li>
                                                    <li><p>Restrict the communication channels we use</p>
                                                    </li>
                                                    <li><p>Encourage our audience to interrupt/pressure
                                                        us</p></li>
                                                    <li className="cntareap"><p>Restrict non-verbal
                                                        communications, e.g. pointing, nodding, etc.</p>
                                                    </li>
                                                </ul>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page4')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}